/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import ReactTooltip from 'react-tooltip';
import {Glyphicon} from 'react-bootstrap';

const TimeInput = ({
  name,
  label,
  onChange,
  placeholder,
  value,
  defaultValue,
  error,
  softError,
  className,
  disabled,
  fieldClass,
  link,
  tooltip,
  onBlur,
  onFocus,
  contextHelp,
  required
}) => {
  let wrapperClass = 'form-group';
  if (error && error.length > 0) {
    wrapperClass += " has-error";
  }
  if (softError && softError.length > 0) {
    wrapperClass += " has-warning";
  }
  return (
    <fieldset className={fieldClass}>
      <div className={wrapperClass}>
        {(label || required || tooltip) && <legend>
          <label htmlFor={name}>
            {label}
            {required && <span className="required-asterisk">*</span>}
            {tooltip && <span className="tooltip-container">
              <Glyphicon glyph="info-sign" className="span-tooltip" 
                data-tip data-for={name}/>
              <ReactTooltip id={name} place="right" type="dark" effect="float">
                <div
                  dangerouslySetInnerHTML={{
                  __html: tooltip
                }}/>
              </ReactTooltip>
            </span>}
          </label>
        </legend>}
        {link && <a name={name} href={link.href} 
          target="_blank">{link.linkText}</a>}
        <div className="field">
          <input
            type="time"
            name={name}
            id={name}
            disabled={disabled}
            className={"form-control input-border " + className}
            placeholder={placeholder}
            value={value}
            defaultValue={defaultValue}
            //WHEN UPGRADED TO REACT 16, replace onInput w/ onChange
            //Currently there is a bug with IE11 where input forms do
            //not behave properly with the onChange property
            onInput={onChange}
            onBlur={onBlur}
            onFocus={onFocus}/> 
            {error && <div tabIndex="0" className="error-message">
              <p>{error}</p>
            </div>}
          {softError && <div className="warning-message">{softError}</div>}
          <div
            className="context-help"
            dangerouslySetInnerHTML={{
            __html: contextHelp
          }}/>
        </div>
      </div>
    </fieldset>
  );
};

TimeInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  softError: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  fieldClass: PropTypes.string,
  link: PropTypes.object,
  passwordReset: PropTypes.string,
  tooltip: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  contextHelp: PropTypes.string,
  required: PropTypes.bool
};

export default TimeInput;



/** WEBPACK FOOTER **
 ** ./src/components/common/TimeInput.js
 **/